export default "__VITE_ASSET__oFnzMrQh__"